import { css } from '@sitebase/emotion';
import { colorMonochromeWhite, sizeBase, colorPrimary100 } from '../settings';

var _ref = 'background-color:';
var _ref2 = ';border-radius:0 0 2px 2px;box-sizing:border-box;font-size:';
var _ref3 = ';left:0;max-height:40px;overflow-y:auto;position:absolute;border:1px solid ';
var _ref4 = ';border-top-width:0;';
export var selectDropdown = function selectDropdown(theme) {
  var isLight = theme === 'light';
  return (/*#__PURE__*/css(_ref, colorMonochromeWhite, _ref2, sizeBase, _ref3, isLight ? colorPrimary100 : 'transparent', _ref4)
  );
};

export var selectDropdownBelow = /*#__PURE__*/css('border-top:0;margin-top:-1px;');

export var selectDropdownAbove = /*#__PURE__*/css('border-bottom:0;margin-bottom:-1px;');